module.exports = __webpack_public_path__ + "img/far-image.b34da7c2.svg";